import { Fragment, memo, ReactElement } from 'react';
import AccordionFilterPerson, {
  validationSchemaResearchPerson,
} from 'civil-status/components/shared/filter-person';
import { Form, Formik } from 'formik';
import { ResearchAct, ResearchPerson } from 'civil-status/view-models/research-category-form';
import FilterAccordionAct from './filter-accordion-act';
import { TypeFilterAct } from 'civil-status/pages/research-category/list';

interface FilterActProps {
  openPerson?: boolean;
  setOpenPerson: (value: boolean) => void;
  openAct?: boolean;
  setOpenAct: (value: boolean) => void;
  idCat?: string;
  handleSubmitResearchAct: (values: ResearchAct) => void;
  handleSubmitResearchPerson: (values: ResearchPerson) => void;
  initialValues?: TypeFilterAct;
}

const FilterActComponent = ({
  openPerson,
  setOpenPerson,
  openAct,
  setOpenAct,
  idCat,
  handleSubmitResearchAct,
  handleSubmitResearchPerson,
  initialValues,
}: FilterActProps): ReactElement => {
  return (
    <Fragment>
      <FilterAccordionAct
        openAct={openAct}
        setOpenAct={setOpenAct}
        idCat={idCat}
        handleSubmitResearchAct={handleSubmitResearchAct}
        initialValues={initialValues?.act}
      />
      <Formik
        initialValues={
          initialValues?.person ||
          ({
            birthDate: undefined,
            fiscalCode: undefined,
            name: undefined,
            surname: undefined,
            idAnpr: undefined,
            idAnsc: undefined,
            isForeign: false,
            municipality: undefined,
            state: undefined,
            gender: undefined,
          } as ResearchPerson)
        }
        onSubmit={(values) => {
          handleSubmitResearchPerson(values);
        }}
        validateOnMount
        validationSchema={validationSchemaResearchPerson}
      >
        <Form>
          <AccordionFilterPerson open={openPerson} setOpen={setOpenPerson} isChoiceList />
        </Form>
      </Formik>
    </Fragment>
  );
};

FilterActComponent.displayName = 'Practice Research - Filter Practice component';

const FilterAct = memo(FilterActComponent);

export default FilterAct;
